import { Component } from '@angular/core';
import { LoadingController, NavController, Platform, ToastController } from 'ionic-angular';
import { DataProvider } from '../../providers/data/data';
import { RestProvider } from '../../providers/rest/rest';

import {BarcodeScannerOptions} from '@ionic-native/barcode-scanner';
import { QRScanner, QRScannerStatus } from '@ionic-native/qr-scanner';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'page-cow-weight',
  templateUrl: 'cow_weight.html'
})
export class Cow_Weight {
  options: BarcodeScannerOptions

  scannedData:any={};

  public CowType;
  public COWS = []
  public farms = [];
  
  public farm: any;
  public Cow_Code: string;
  public Cow_Name: string;
  public Birth_Date: Date;
  public Sex: any;
  public Cow_Type: any;
  public Cow_Status: any;
  public Cow_Weight: any;
  public Cow_Temperature: any;
  public Cow_Height: any;
  public loader;

  constructor(public navCtrl: NavController,
    private rest: RestProvider,
    private data: DataProvider,
    private toastCtrl: ToastController,
    private qrScanner: QRScanner,
    private loadingCtrl: LoadingController,
    protected datepipe: DatePipe,
    public plt: Platform) {;

  }
  ionViewDidLoad() {
    this.farms = JSON.parse(localStorage.getItem('farms'));
  }
  
  ionViewDidEnter(): void {
    document.getElementById('mainmenu').style.visibility = 'visible';
    document.getElementById('backmenu').style.display = 'block';
    document.getElementById('mainHeader').style.display = 'block';
    document.getElementById('backFrom').innerText = '';
    this.data.currentTabName = 'Үхрийн жин оруулах';
  }
  showToast1(str: any) {
    let toast = this.toastCtrl.create({
      message: str,
      position: 'middle',
      duration: 3000,
      cssClass: "toast-unsuccess"
    });
    toast.present();
  }
  showToast(str: any) {
    let toast = this.toastCtrl.create({
      message: str,
      position: 'middle',
      duration: 3000,
      cssClass: "toast-success"
    });
    toast.present();
  }
  Save(){
    if(this.Cow_Code == null || this.Cow_Code == ''){
      this.showToast1('Та QR уншуулна уу.');
      return;
    }
    if(this.Cow_Weight == null || this.Cow_Weight == ''){
      this.showToast1('Та Үхрийн жинг оруулна уу.');
      return;
    }
    if(this.Cow_Temperature == null || this.Cow_Temperature == ''){
      this.showToast1('Та Үхрийн халууныг оруулна уу.');
      return;
    }
    if(this.Cow_Height == null || this.Cow_Height == ''){
      this.showToast1('Та Үхрийн өндөрийг оруулна уу.');
      return;
    }
    var myCurrentDate=new Date();
    this.datepipe.transform(myCurrentDate, 'yyyy-MM-dd HH:mm:ss'),
    this.rest.InsertWeight(
      this.data.userId,
      this.Cow_Code,
      myCurrentDate,
      this.Cow_Weight,
      this.Cow_Temperature,
      this.Cow_Height
      ).subscribe(res => {
        if(res.result == true){
          this.showToast('Амжилттай хадгаллаа.');
        }else if(res.result == false){
          this.showToast1('Алдаатай.');
        }
    })
  }
  showLoader(content?: string) {
    if (this.loader) {
      this.loader.dismiss();
    }
    this.loader = this.loadingCtrl.create({ 
      content: content ? content : "Ачаалж байна..."
    })
    this.loader.present();
    this.loader.onDidDismiss(()=>{
      this.loader = null;
    })
  }
  hideLoader() {
    if(this.loader)
      this.loader.dismiss();
  }
  preview = (show: boolean): void => {
    if (show) {
      (window.document.querySelector("ion-app") as HTMLElement).classList.add("cameraView");
      window.document.body.style.backgroundColor = "transparent";
      document.getElementById('qrreader').style.display = 'none';
    } else {
      (window.document.querySelector("ion-app") as HTMLElement).classList.remove("cameraView");
      window.document.body.style.backgroundColor = '#FFF';
      document.getElementById('qrreader').style.display = 'block';
    }
  }
  qrread() {
    this.qrScanner.prepare()
    .then((status: QRScannerStatus) => {
      if (status.authorized) {
        this.preview(true);
        // camera permission was granted
        // start scanning
        let scanSub = this.qrScanner.scan().subscribe((text: any) => {
          console.log('Scanned something', text);
          this.Cow_Code = text.result;
          this.preview(false);
          this.qrScanner.hide(); // hide camera preview
          scanSub.unsubscribe(); // stop scanning
        });

      } else if (status.denied) {
        // camera permission was permanently denied
        // you must use QRScanner.openSettings() method to guide the user to the settings page
        // then they can grant the permission from there
        this.showToast('Та камераа ашиглахыг зөвшөөрнө үү!');
      } else {
        // permission was denied, but not permanently. You can ask for permission again at a later time.
        this.showToast('Та камераа ашиглахыг зөвшөөрнө үү!');
      }
    })
    .catch((e: any) => {
      console.log('Error is', e);
      this.showToast('Та камераа ашиглахыг зөвшөөрнө үү!' + e);
    });
  }
  scanSub: any;
  QRSCAN(){
    this.qrScanner.prepare().
    then((status: QRScannerStatus) => {
      if (status.authorized) {
        this.qrScanner.show();
        this.scanSub = document.getElementsByTagName('body')[0].style.opacity = '0';
        debugger
        this.scanSub = this.qrScanner.scan()
          .subscribe((textFound: string) => {
            document.getElementsByTagName('body')[0].style.opacity = '1';
            this.qrScanner.hide();
            this.scanSub.unsubscribe();
            
            this.showLoader();
            this.Cow_Code = textFound;
            this.rest.QRSCANNER(
              this.Cow_Code
            ).subscribe(res =>{
              if(res.result == false){
                this.showToast1('Ийм QR тай үхэр олдсонгүй.');
                this.Cow_Name = '';
                this.Birth_Date = null;
                this.Sex = '';
                this.Cow_Type = '';
                this.Cow_Status = '';
                this.hideLoader();
              }else{
                this.COWS = res;
                console.log(this.COWS)
                this.Cow_Name = this.COWS[0]["cow_name"];
                this.Birth_Date = this.COWS[0]["birth_date"];
                this.Sex = this.COWS[0]["sex"];
                this.Cow_Type = this.COWS[0]["cow_type"];
                this.Cow_Status = this.COWS[0]["cow_status"];
                this.hideLoader();
              }
            })
          }, (err) => {
            alert(JSON.stringify(err));
          });

      } else if (status.denied) {
      } else {

      }
    })
    .catch((e: any) => console.log('Error is', e));
    
  }
  QRSCANCOMPUTER(Cow_Code){
    console.log(Cow_Code);
    this.rest.QRSCANNER(
      Cow_Code
    ).subscribe(res =>{
      if(res.result == false){
        this.showToast1('Ийм QR тай үхэр олдсонгүй.');
        this.Cow_Name = '';
        this.Birth_Date = null;
        this.Sex = '';
        this.Cow_Type = '';
        this.Cow_Status = '';
        this.hideLoader();
      }else{
        this.COWS = res;
        console.log(this.COWS)
        this.Cow_Name = this.COWS[0]["cow_name"];
        this.Birth_Date = this.COWS[0]["birth_date"];
        this.Sex = this.COWS[0]["sex"];
        this.Cow_Type = this.COWS[0]["cow_type"];
        this.Cow_Status = this.COWS[0]["cow_status"];
        this.hideLoader();
      }
    },
    (err) => {
      this.hideLoader();
    })
  }
}



// WEBPACK FOOTER //
// ./src/pages/cow_weight/cow_weight.ts